import {useEffect, useState} from 'react';
import type {AppModel} from '../../bff/app-model/create-content-model';
import {fetchAppModel} from '../utils/fetch-app-model';
import {useFeatureAppEnvHook} from './use-feature-app-env';
import {useLocale} from './use-locale';

export function useAppModel(
  done: (error?: Error) => void = () => {},
): AppModel | undefined {
  const [appModel, setAppModel] = useState<AppModel | undefined>();
  const {baseUrl, featureServices, config} = useFeatureAppEnvHook();
  const {'endpoint-directory': endpointDirectory} = featureServices;
  const locale = useLocale();
  const [error, setError] = useState<unknown>();

  if (error) {
    throw error;
  }

  useEffect(() => {
    const abortController = new AbortController();

    const promise = fetchAppModel(
      baseUrl,
      {
        endpointDirectory,
        locale,
        config,
      },
      abortController.signal,
    );

    promise
      .then((data) => {
        setAppModel(data);
        done();
      })
      .catch((fetchError) => {
        setError(fetchError);
        if (!abortController.signal.aborted) {
          done(fetchError);
        }
      });
  }, [baseUrl, endpointDirectory, locale, config]);

  return appModel;
}
